import { render, staticRenderFns } from "./DunningAlert.vue?vue&type=template&id=985bd78e&"
import script from "./DunningAlert.vue?vue&type=script&lang=js&"
export * from "./DunningAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports